import React, { useCallback, useContext, useState, useEffect, useMemo } from "react";
import { Popover, Button, Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { openJoinMeetingModal } from "@/utils/modals";
import useGroupUserSelector from "@/components/chat/GroupUserSelector";
import EventBus from "@/utils/bus";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import { isFocusEnv } from "@/utils";
import cache from "@/utils/cache";
import Cookies from "js-cookie";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import log from "@/utils/logger";
import config, { ConfigEnum } from "@/config/config";
import { IconAdd, IconGroup, IconJoyMeetingGroup } from "@/components/icon";
import "./AddPopover.less";
import { userDataStore } from "@/utils/user";
import bus from "@/utils/bus";
import { crossAppSwitch } from "@/utils/tools";
import IconFont from "@/components/icon";
const logger = log.getLogger("Search");

export enum CreateBtnType {
  Group = "group",
  Zhuanban = "zhuanban",
  Meeting = "meeting",
  JoinMeeting = "join-meeting",
  AppointmentMeeting = "appointment-meeting",
  Contact = "Contact",
  JoinTeam = "JoinTeam"
}

function AddPopover({
  userData,
  currentEmployee,
  openCreateScheduleModal,
  openCreateContactModal,
  getCurrentEmployee,
  themes
}: {
  userData: any;
  currentEmployee: any;
  openCreateScheduleModal: (data: any) => void;
  openCreateContactModal: (data: any) => void;
  getCurrentEmployee: Function;
  themes: any;
}) {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation("common");
  const { focusSDK, appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  useEffect(() => {
    if (!currentEmployee) {
      getCurrentEmployee();
    }
  }, [currentEmployee, getCurrentEmployee]);

  const openCreateGroupModal = useGroupUserSelector({
    currentEmployee,
    userData: userData ? userData.user : null,
    sessionMembers: [currentEmployee]
  });
  const openJoinTeamModal = () => {
    bus.emit("openJoinTeamModal", {
      teamId: currentEmployee?.teamId
    });
  };
  const onCreateBtnClick = useCallback(
    (btnType) => {
      switch (btnType) {
        case CreateBtnType.Group:
          openCreateGroupModal();
          break;
        case CreateBtnType.Contact:
          openCreateContactModal({ visible: true });
          break;
        case CreateBtnType.JoinTeam:
          openJoinTeamModal();
          break;

        // 创建专班
        // 需求变更：隐藏专班入口：2021.3.22
        // case CreateBtnType.Zhuanban:
        //     history.push({
        //         pathname: 'Projects',
        //         search: qs.stringify({ from: 'message' }),
        //     });
        //     break;
        case CreateBtnType.Meeting:
          EventBus.emit("meeting:create-show");
          break;
        case CreateBtnType.AppointmentMeeting:
          openCreateScheduleModal({ visible: true, defaultAppointment: true });
          break;
        default:
          return;
      }
    },
    [openCreateGroupModal, openCreateContactModal, openCreateScheduleModal]
  );
  const getCreateButtons = useCallback(() => {
    const buttons = [CreateBtnType.Group, CreateBtnType.Contact];
    // 显示创建专班入口
    // isGovEnv && buttons.push(CreateBtnType.Zhuanban); 需求变更：隐藏专班入口
    const isFocus = isFocusEnv();
    buttons.push(CreateBtnType.JoinMeeting);
    if (isFocus) {
      buttons.push(CreateBtnType.Meeting);
    }
    if (isFocus && config[ConfigEnum.TOP_BAR_MENU_MEETING_APPOINT]) {
      buttons.push(CreateBtnType.AppointmentMeeting);
    }
    return buttons;
  }, []);
  let buttons = [
    {
      key: CreateBtnType.Group,
      icon: IconGroup,
      text: t("createButton.createGroup"),
      clstag: "Xtbg_Msg_Home|AddGroup"
    },
    {
      key: CreateBtnType.Contact,
      icon: IconJoyMeetingGroup,
      text: t("createButton.addContact"),
      clstag: "Xtbg_Msg_Home|AddContact"
    }

    // { key: CreateBtnType.Zhuanban, icon: IconZhuanban, text: t('createButton.createZhuanban') },
    // {
    //     key: CreateBtnType.Meeting,
    //     icon: IconMeeting,
    //     text: t('createButton.createMeeting'),
    //     clstag: 'pageclick|keycount|focus_home_01_1615797361152|3',
    // },
    // {
    //     key: CreateBtnType.JoinMeeting,
    //     icon: IconJoinMeeting,
    //     text: t('createButton.joinMeeting'),
    //     clstag: 'pageclick|keycount|focus_home_01_1615797361152|4',
    // },
    // {
    //     key: CreateBtnType.AppointmentMeeting,
    //     icon: IconAppointMeeting,
    //     text: t('createButton.appointMeeting'),
    //     clstag: 'pageclick|keycount|focus_home_01_1615797361152|5',
    // },
  ];
  if (Array.isArray(getCreateButtons)) {
    buttons = buttons.filter((item) => getCreateButtons.findIndex((k) => k === item.key) >= 0);
  }
  if (!config[ConfigEnum.EXTERNAL_CONTACTS_ADD_CONTACTS]) {
    buttons = buttons.filter((item) => item.key !== CreateBtnType.Contact);
  }

  if (crossAppSwitch("selfRegistration") && userDataStore?.userDetail?.canInvite) {
    buttons.push({
      key: CreateBtnType.JoinTeam,
      icon: IconJoyMeetingGroup,
      text: t("createButton.joinTeam"),
      clstag: "Xtbg_Msg_Home|AddContact"
    });
  }
  const content = (
    <div className="create-buttons">
      {buttons.map((btn) => (
        <div
          key={btn.key}
          className="create-btn-item create-btn-item1"
          onClick={() => {
            onCreateBtnClick(btn.key);
            setVisible(false);
          }}
          clstag={`pageclick|keycount|${btn.clstag}`}
        >
          {btn.icon}
          <div style={{ marginLeft: 6 }}>{btn.text}</div>
        </div>
      ))}
    </div>
  );

  return (
    <Popover
      content={content}
      overlayClassName="focus-create-button"
      trigger="click"
      visible={visible}
      align={{
        offset: [0, -8]
      }}
      placement="bottom"
      onVisibleChange={(visible) => {
        setVisible(visible);
      }}
    >
      <div className={`add-create ${themes}theme`}>
        <IconFont type="iconquanjuchuangjian" style={{fontSize: 28}}/>
      </div>
    </Popover>
  );
}

function mapStateToProps(props: { user: any; chat: ChatState }) {
  const { user, chat } = props;
  return {
    userData: user.userData,
    currentEmployee: chat.currentEmployee,
    themes: user.themes
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateScheduleModal(data: any) {
      dispatch({ type: "calendar/openCreateModal", payload: data });
    },
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    },
    getCurrentEmployee: () => {
      dispatch({ type: "chat/getCurrentEmployee", payload: {} });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddPopover);
